export default "__VITE_ASSET__CICVU4Bf__"